<template>
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <div
      class="d-flex flex-column justify-center align-center"
      :style="{
        'text-align': 'center',
        width: '70%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <h4>Apakah Calon Merchant telah memiliki rekening bank BNI ?</h4>
      <p>Silahkan masukkan rekening giro atau rekening tabungan merchant.</p>
      <v-radio-group row v-model="rekening">
        <v-radio label="Belum" value="0" selected />
        <v-radio label="Sudah" value="1" />
        <v-text-field
          label="Masukkan nomor rekening"
          v-if="rekening == 1"
          v-model="noRekening"
          :error-messages="noRekeningErrors"
          @input="$v.noRekening.$touch()"
          @blur="$v.noRekening.$touch()"
          :disabled="isLoading"
        />
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="yellow darken-2"
        />
      </v-radio-group>
      <v-alert
        v-if="rekening == 0"
        border="left"
        color="warning"
        elevation="2"
        :style="{ 'text-align': 'left', color: 'white' }"
      >
        <h3 :style="{ color: 'darkred' }">Perhatian !</h3>
        <p>
          Jika merchant belum memiliki rekening BNI, maka Anda belum dapat
          melanjutkan proses pendaftaran. Klik
          <a
            href="https://www.bni.co.id/id-id/bukatabungandigital"
            target="_blank"
            rel="noopener"
            >link berikut</a
          >
          untuk mendapatkan panduan pembukaan rekening digital BNI
        </p>
      </v-alert>
      <v-alert
        v-if="showInvalid && !valid"
        border="left"
        color="warning"
        elevation="2"
        :style="{ 'text-align': 'left', color: 'white' }"
      >
        <h3 :style="{ color: 'darkred' }">Perhatian !</h3>
        <p>
          Nomor Rekening yang Anda input tidak valid. Anda tidak dapat
          melanjutkan proses pendaftaran
        </p>
      </v-alert>
      <v-alert
        v-if="showRegistered && !valid"
        border="left"
        color="warning"
        elevation="2"
        :style="{ 'text-align': 'left', color: 'white' }"
      >
        <h3 :style="{ color: 'darkred' }">Perhatian !</h3>
        <p>Nomor Rekening yang Anda input telah terdaftar sebelumnya.</p>
      </v-alert>
      <v-row align="center">
        <v-btn
          small
          color="warning"
          :disabled="isLoading"
          @click="prevStep"
          :style="{ margin: '2px' }"
        >
          <v-icon dark left> mdi-arrow-left </v-icon>Kembali
        </v-btn>
        <v-btn
          v-if="rekening == 1"
          small
          color="primary"
          @click="nextStep"
          :style="{ margin: '2px' }"
          :disabled="isLoading"
        >
          Lanjut
          <v-icon dark right> mdi-arrow-right </v-icon>
        </v-btn>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { numeric } from 'vuelidate/lib/validators';
import { date } from '../../lib/helpers';

export default {
  name: 'step1',
  mixins: [validationMixin],

  validations: {
    noRekening: {
      required() {
        return this.rekening == '1' && this.noRekening != '';
      },
      isRekVc() {
        return (
          this.noRekening.length == 9 ||
          this.noRekening.length == 10 ||
          this.noRekening.length == 16
        );
      },
      numeric,
    },
  },
  data() {
    return {
      rekening: '1',
      isLoading: false,
      showInvalid: false,
      showRegistered: false,
      no_rekening_old: '',
      valid: false,
      continue: 1,
    };
  },
  watch: {
    rekening(val) {
      if (val == '0') {
        this.clearInvalid();
      }
    },
  },
  computed: {
    noRekeningErrors() {
      const errors = [];
      if (!this.$v.noRekening.$dirty) return errors;
      if (!this.$v.noRekening.required) errors.push('No Rekening is required');
      if (!this.$v.noRekening.numeric) errors.push('Must be numeric');
      if (!this.$v.noRekening.isRekVc) {
        errors.push('Must be 9-10 or 16 digits');
      }
      return errors;
    },
    noRekening: {
      set(val) {
        this.$store.commit('register/setNoRekening', val);
      },
      get() {
        return this.$store.state.register.data.noRekening;
      },
    },
  },
  mounted() {
    if (
      this.$route.params.id != undefined ||
      this.$route.params.idAggregator != undefined
    ) {
      this.$store.commit('register/setStep', 6);
    } else {
      this.$store.commit('register/setStep', 1);
    }
  },
  methods: {
    prevStep() {
      this.$router.push('/');
    },
    nextStep() {
      this.$v.$touch();
      this.clearInvalid();
      if (!this.$v.$invalid) {
        this.isLoading = true;
        this.$store
          .dispatch('rekening/validate', {
            date,
            no_rekening: this.noRekening,
          })
          .then((response) => {
            if (response) {
              if (response == 'registered') {
                this.valid = false;
                this.showRegistered = true;
              } else {
                this.valid = true;
                this.showInvalid = false;
                this.$store.commit('register/setValidRekening', this.valid);
                this.$store.commit('register/setStep', 2);
              }
            } else {
              this.valid = false;
              this.showInvalid = true;
            }
          })
          .catch(() => {})
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    clearInvalid() {
      this.showRegistered = false;
      this.showInvalid = false;
    },
  },
};
</script>
